/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import { __assign } from "tslib";
import { CloudErrorMapper, BaseResourceMapper } from "@azure/ms-rest-azure-js";
export var CloudError = CloudErrorMapper;
export var BaseResource = BaseResourceMapper;
export var InformationalUrl = {
    serializedName: "InformationalUrl",
    type: {
        name: "Composite",
        className: "InformationalUrl",
        modelProperties: {
            termsOfService: {
                serializedName: "termsOfService",
                type: {
                    name: "String"
                }
            },
            marketing: {
                serializedName: "marketing",
                type: {
                    name: "String"
                }
            },
            privacy: {
                serializedName: "privacy",
                type: {
                    name: "String"
                }
            },
            support: {
                serializedName: "support",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var OAuth2Permission = {
    serializedName: "OAuth2Permission",
    type: {
        name: "Composite",
        className: "OAuth2Permission",
        modelProperties: {
            adminConsentDescription: {
                serializedName: "adminConsentDescription",
                type: {
                    name: "String"
                }
            },
            adminConsentDisplayName: {
                serializedName: "adminConsentDisplayName",
                type: {
                    name: "String"
                }
            },
            id: {
                serializedName: "id",
                type: {
                    name: "String"
                }
            },
            isEnabled: {
                serializedName: "isEnabled",
                type: {
                    name: "Boolean"
                }
            },
            type: {
                serializedName: "type",
                type: {
                    name: "String"
                }
            },
            userConsentDescription: {
                serializedName: "userConsentDescription",
                type: {
                    name: "String"
                }
            },
            userConsentDisplayName: {
                serializedName: "userConsentDisplayName",
                type: {
                    name: "String"
                }
            },
            value: {
                serializedName: "value",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var OptionalClaim = {
    serializedName: "OptionalClaim",
    type: {
        name: "Composite",
        className: "OptionalClaim",
        modelProperties: {
            name: {
                serializedName: "name",
                type: {
                    name: "String"
                }
            },
            source: {
                serializedName: "source",
                type: {
                    name: "String"
                }
            },
            essential: {
                serializedName: "essential",
                type: {
                    name: "Boolean"
                }
            },
            additionalProperties: {
                serializedName: "additionalProperties",
                type: {
                    name: "Object"
                }
            }
        }
    }
};
export var OptionalClaims = {
    serializedName: "OptionalClaims",
    type: {
        name: "Composite",
        className: "OptionalClaims",
        modelProperties: {
            idToken: {
                serializedName: "idToken",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "OptionalClaim"
                        }
                    }
                }
            },
            accessToken: {
                serializedName: "accessToken",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "OptionalClaim"
                        }
                    }
                }
            },
            samlToken: {
                serializedName: "samlToken",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "OptionalClaim"
                        }
                    }
                }
            }
        }
    }
};
export var PreAuthorizedApplicationPermission = {
    serializedName: "PreAuthorizedApplicationPermission",
    type: {
        name: "Composite",
        className: "PreAuthorizedApplicationPermission",
        modelProperties: {
            directAccessGrant: {
                serializedName: "directAccessGrant",
                type: {
                    name: "Boolean"
                }
            },
            accessGrants: {
                serializedName: "accessGrants",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var PreAuthorizedApplicationExtension = {
    serializedName: "PreAuthorizedApplicationExtension",
    type: {
        name: "Composite",
        className: "PreAuthorizedApplicationExtension",
        modelProperties: {
            conditions: {
                serializedName: "conditions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var PreAuthorizedApplication = {
    serializedName: "PreAuthorizedApplication",
    type: {
        name: "Composite",
        className: "PreAuthorizedApplication",
        modelProperties: {
            appId: {
                serializedName: "appId",
                type: {
                    name: "String"
                }
            },
            permissions: {
                serializedName: "permissions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PreAuthorizedApplicationPermission"
                        }
                    }
                }
            },
            extensions: {
                serializedName: "extensions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PreAuthorizedApplicationExtension"
                        }
                    }
                }
            }
        }
    }
};
export var GraphError = {
    serializedName: "GraphError",
    type: {
        name: "Composite",
        className: "GraphError",
        modelProperties: {
            code: {
                serializedName: "odata\\.error.code",
                type: {
                    name: "String"
                }
            },
            message: {
                serializedName: "odata\\.error.message.value",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var DirectoryObject = {
    serializedName: "DirectoryObject",
    type: {
        name: "Composite",
        polymorphicDiscriminator: {
            serializedName: "objectType",
            clientName: "objectType"
        },
        uberParent: "DirectoryObject",
        className: "DirectoryObject",
        modelProperties: {
            objectId: {
                readOnly: true,
                serializedName: "objectId",
                type: {
                    name: "String"
                }
            },
            deletionTimestamp: {
                readOnly: true,
                serializedName: "deletionTimestamp",
                type: {
                    name: "DateTime"
                }
            },
            objectType: {
                required: true,
                serializedName: "objectType",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var KeyCredential = {
    serializedName: "KeyCredential",
    type: {
        name: "Composite",
        className: "KeyCredential",
        modelProperties: {
            startDate: {
                serializedName: "startDate",
                type: {
                    name: "DateTime"
                }
            },
            endDate: {
                serializedName: "endDate",
                type: {
                    name: "DateTime"
                }
            },
            value: {
                serializedName: "value",
                type: {
                    name: "String"
                }
            },
            keyId: {
                serializedName: "keyId",
                type: {
                    name: "String"
                }
            },
            usage: {
                serializedName: "usage",
                type: {
                    name: "String"
                }
            },
            type: {
                serializedName: "type",
                type: {
                    name: "String"
                }
            },
            customKeyIdentifier: {
                serializedName: "customKeyIdentifier",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var PasswordCredential = {
    serializedName: "PasswordCredential",
    type: {
        name: "Composite",
        className: "PasswordCredential",
        modelProperties: {
            startDate: {
                serializedName: "startDate",
                type: {
                    name: "DateTime"
                }
            },
            endDate: {
                serializedName: "endDate",
                type: {
                    name: "DateTime"
                }
            },
            keyId: {
                serializedName: "keyId",
                type: {
                    name: "String"
                }
            },
            value: {
                serializedName: "value",
                type: {
                    name: "String"
                }
            },
            customKeyIdentifier: {
                serializedName: "customKeyIdentifier",
                type: {
                    name: "ByteArray"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var ResourceAccess = {
    serializedName: "ResourceAccess",
    type: {
        name: "Composite",
        className: "ResourceAccess",
        modelProperties: {
            id: {
                required: true,
                serializedName: "id",
                type: {
                    name: "String"
                }
            },
            type: {
                serializedName: "type",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var RequiredResourceAccess = {
    serializedName: "RequiredResourceAccess",
    type: {
        name: "Composite",
        className: "RequiredResourceAccess",
        modelProperties: {
            resourceAccess: {
                required: true,
                serializedName: "resourceAccess",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "ResourceAccess",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            },
            resourceAppId: {
                serializedName: "resourceAppId",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var AppRole = {
    serializedName: "AppRole",
    type: {
        name: "Composite",
        className: "AppRole",
        modelProperties: {
            id: {
                serializedName: "id",
                type: {
                    name: "String"
                }
            },
            allowedMemberTypes: {
                serializedName: "allowedMemberTypes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            description: {
                serializedName: "description",
                type: {
                    name: "String"
                }
            },
            displayName: {
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            },
            isEnabled: {
                serializedName: "isEnabled",
                type: {
                    name: "Boolean"
                }
            },
            value: {
                serializedName: "value",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var ApplicationBase = {
    serializedName: "ApplicationBase",
    type: {
        name: "Composite",
        className: "ApplicationBase",
        modelProperties: {
            allowGuestsSignIn: {
                serializedName: "allowGuestsSignIn",
                type: {
                    name: "Boolean"
                }
            },
            allowPassthroughUsers: {
                serializedName: "allowPassthroughUsers",
                type: {
                    name: "Boolean"
                }
            },
            appLogoUrl: {
                serializedName: "appLogoUrl",
                type: {
                    name: "String"
                }
            },
            appRoles: {
                serializedName: "appRoles",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "AppRole"
                        }
                    }
                }
            },
            appPermissions: {
                serializedName: "appPermissions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            availableToOtherTenants: {
                serializedName: "availableToOtherTenants",
                type: {
                    name: "Boolean"
                }
            },
            errorUrl: {
                serializedName: "errorUrl",
                type: {
                    name: "String"
                }
            },
            groupMembershipClaims: {
                serializedName: "groupMembershipClaims",
                type: {
                    name: "Object"
                }
            },
            homepage: {
                serializedName: "homepage",
                type: {
                    name: "String"
                }
            },
            informationalUrls: {
                serializedName: "informationalUrls",
                type: {
                    name: "Composite",
                    className: "InformationalUrl"
                }
            },
            isDeviceOnlyAuthSupported: {
                serializedName: "isDeviceOnlyAuthSupported",
                type: {
                    name: "Boolean"
                }
            },
            keyCredentials: {
                serializedName: "keyCredentials",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "KeyCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            },
            knownClientApplications: {
                serializedName: "knownClientApplications",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            logoutUrl: {
                serializedName: "logoutUrl",
                type: {
                    name: "String"
                }
            },
            oauth2AllowImplicitFlow: {
                serializedName: "oauth2AllowImplicitFlow",
                type: {
                    name: "Boolean"
                }
            },
            oauth2AllowUrlPathMatching: {
                serializedName: "oauth2AllowUrlPathMatching",
                type: {
                    name: "Boolean"
                }
            },
            oauth2Permissions: {
                serializedName: "oauth2Permissions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "OAuth2Permission"
                        }
                    }
                }
            },
            oauth2RequirePostResponse: {
                serializedName: "oauth2RequirePostResponse",
                type: {
                    name: "Boolean"
                }
            },
            orgRestrictions: {
                serializedName: "orgRestrictions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            optionalClaims: {
                serializedName: "optionalClaims",
                type: {
                    name: "Composite",
                    className: "OptionalClaims"
                }
            },
            passwordCredentials: {
                serializedName: "passwordCredentials",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PasswordCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            },
            preAuthorizedApplications: {
                serializedName: "preAuthorizedApplications",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PreAuthorizedApplication"
                        }
                    }
                }
            },
            publicClient: {
                serializedName: "publicClient",
                type: {
                    name: "Boolean"
                }
            },
            publisherDomain: {
                serializedName: "publisherDomain",
                type: {
                    name: "String"
                }
            },
            replyUrls: {
                serializedName: "replyUrls",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            requiredResourceAccess: {
                serializedName: "requiredResourceAccess",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "RequiredResourceAccess",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            },
            samlMetadataUrl: {
                serializedName: "samlMetadataUrl",
                type: {
                    name: "String"
                }
            },
            signInAudience: {
                serializedName: "signInAudience",
                type: {
                    name: "String"
                }
            },
            wwwHomepage: {
                serializedName: "wwwHomepage",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var ApplicationCreateParameters = {
    serializedName: "ApplicationCreateParameters",
    type: {
        name: "Composite",
        className: "ApplicationCreateParameters",
        modelProperties: __assign(__assign({}, ApplicationBase.type.modelProperties), { displayName: {
                required: true,
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            }, identifierUris: {
                serializedName: "identifierUris",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            } })
    }
};
export var ApplicationUpdateParameters = {
    serializedName: "ApplicationUpdateParameters",
    type: {
        name: "Composite",
        className: "ApplicationUpdateParameters",
        modelProperties: __assign(__assign({}, ApplicationBase.type.modelProperties), { displayName: {
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            }, identifierUris: {
                serializedName: "identifierUris",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            } })
    }
};
export var Application = {
    serializedName: "Application",
    type: {
        name: "Composite",
        polymorphicDiscriminator: DirectoryObject.type.polymorphicDiscriminator,
        uberParent: "DirectoryObject",
        className: "Application",
        modelProperties: __assign(__assign({}, DirectoryObject.type.modelProperties), { appId: {
                serializedName: "appId",
                type: {
                    name: "String"
                }
            }, allowGuestsSignIn: {
                serializedName: "allowGuestsSignIn",
                type: {
                    name: "Boolean"
                }
            }, allowPassthroughUsers: {
                serializedName: "allowPassthroughUsers",
                type: {
                    name: "Boolean"
                }
            }, appLogoUrl: {
                serializedName: "appLogoUrl",
                type: {
                    name: "String"
                }
            }, appRoles: {
                serializedName: "appRoles",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "AppRole"
                        }
                    }
                }
            }, appPermissions: {
                serializedName: "appPermissions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }, availableToOtherTenants: {
                serializedName: "availableToOtherTenants",
                type: {
                    name: "Boolean"
                }
            }, displayName: {
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            }, errorUrl: {
                serializedName: "errorUrl",
                type: {
                    name: "String"
                }
            }, groupMembershipClaims: {
                serializedName: "groupMembershipClaims",
                type: {
                    name: "Object"
                }
            }, homepage: {
                serializedName: "homepage",
                type: {
                    name: "String"
                }
            }, identifierUris: {
                serializedName: "identifierUris",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }, informationalUrls: {
                serializedName: "informationalUrls",
                type: {
                    name: "Composite",
                    className: "InformationalUrl"
                }
            }, isDeviceOnlyAuthSupported: {
                serializedName: "isDeviceOnlyAuthSupported",
                type: {
                    name: "Boolean"
                }
            }, keyCredentials: {
                serializedName: "keyCredentials",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "KeyCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }, knownClientApplications: {
                serializedName: "knownClientApplications",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }, logoutUrl: {
                serializedName: "logoutUrl",
                type: {
                    name: "String"
                }
            }, oauth2AllowImplicitFlow: {
                serializedName: "oauth2AllowImplicitFlow",
                type: {
                    name: "Boolean"
                }
            }, oauth2AllowUrlPathMatching: {
                serializedName: "oauth2AllowUrlPathMatching",
                type: {
                    name: "Boolean"
                }
            }, oauth2Permissions: {
                serializedName: "oauth2Permissions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "OAuth2Permission"
                        }
                    }
                }
            }, oauth2RequirePostResponse: {
                serializedName: "oauth2RequirePostResponse",
                type: {
                    name: "Boolean"
                }
            }, orgRestrictions: {
                serializedName: "orgRestrictions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }, optionalClaims: {
                serializedName: "optionalClaims",
                type: {
                    name: "Composite",
                    className: "OptionalClaims"
                }
            }, passwordCredentials: {
                serializedName: "passwordCredentials",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PasswordCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }, preAuthorizedApplications: {
                serializedName: "preAuthorizedApplications",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PreAuthorizedApplication"
                        }
                    }
                }
            }, publicClient: {
                serializedName: "publicClient",
                type: {
                    name: "Boolean"
                }
            }, publisherDomain: {
                serializedName: "publisherDomain",
                type: {
                    name: "String"
                }
            }, replyUrls: {
                serializedName: "replyUrls",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }, requiredResourceAccess: {
                serializedName: "requiredResourceAccess",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "RequiredResourceAccess",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }, samlMetadataUrl: {
                serializedName: "samlMetadataUrl",
                type: {
                    name: "String"
                }
            }, signInAudience: {
                serializedName: "signInAudience",
                type: {
                    name: "String"
                }
            }, wwwHomepage: {
                serializedName: "wwwHomepage",
                type: {
                    name: "String"
                }
            } }),
        additionalProperties: DirectoryObject.type.additionalProperties
    }
};
export var ServicePrincipalObjectResult = {
    serializedName: "ServicePrincipalObjectResult",
    type: {
        name: "Composite",
        className: "ServicePrincipalObjectResult",
        modelProperties: {
            value: {
                serializedName: "value",
                type: {
                    name: "String"
                }
            },
            odatametadata: {
                serializedName: "odata\\.metadata",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var AddOwnerParameters = {
    serializedName: "AddOwnerParameters",
    type: {
        name: "Composite",
        className: "AddOwnerParameters",
        modelProperties: {
            url: {
                required: true,
                serializedName: "url",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var KeyCredentialsUpdateParameters = {
    serializedName: "KeyCredentialsUpdateParameters",
    type: {
        name: "Composite",
        className: "KeyCredentialsUpdateParameters",
        modelProperties: {
            value: {
                required: true,
                serializedName: "value",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "KeyCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
export var PasswordCredentialsUpdateParameters = {
    serializedName: "PasswordCredentialsUpdateParameters",
    type: {
        name: "Composite",
        className: "PasswordCredentialsUpdateParameters",
        modelProperties: {
            value: {
                required: true,
                serializedName: "value",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PasswordCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
export var GroupAddMemberParameters = {
    serializedName: "GroupAddMemberParameters",
    type: {
        name: "Composite",
        className: "GroupAddMemberParameters",
        modelProperties: {
            url: {
                required: true,
                serializedName: "url",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var GroupCreateParameters = {
    serializedName: "GroupCreateParameters",
    type: {
        name: "Composite",
        className: "GroupCreateParameters",
        modelProperties: {
            displayName: {
                required: true,
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            },
            mailEnabled: {
                required: true,
                isConstant: true,
                serializedName: "mailEnabled",
                defaultValue: false,
                type: {
                    name: "Boolean"
                }
            },
            mailNickname: {
                required: true,
                serializedName: "mailNickname",
                type: {
                    name: "String"
                }
            },
            securityEnabled: {
                required: true,
                isConstant: true,
                serializedName: "securityEnabled",
                defaultValue: true,
                type: {
                    name: "Boolean"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var ADGroup = {
    serializedName: "Group",
    type: {
        name: "Composite",
        polymorphicDiscriminator: DirectoryObject.type.polymorphicDiscriminator,
        uberParent: "DirectoryObject",
        className: "ADGroup",
        modelProperties: __assign(__assign({}, DirectoryObject.type.modelProperties), { displayName: {
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            }, mailEnabled: {
                serializedName: "mailEnabled",
                type: {
                    name: "Boolean"
                }
            }, mailNickname: {
                serializedName: "mailNickname",
                type: {
                    name: "String"
                }
            }, securityEnabled: {
                serializedName: "securityEnabled",
                type: {
                    name: "Boolean"
                }
            }, mail: {
                serializedName: "mail",
                type: {
                    name: "String"
                }
            } }),
        additionalProperties: DirectoryObject.type.additionalProperties
    }
};
export var GroupGetMemberGroupsParameters = {
    serializedName: "GroupGetMemberGroupsParameters",
    type: {
        name: "Composite",
        className: "GroupGetMemberGroupsParameters",
        modelProperties: {
            securityEnabledOnly: {
                required: true,
                serializedName: "securityEnabledOnly",
                type: {
                    name: "Boolean"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var CheckGroupMembershipParameters = {
    serializedName: "CheckGroupMembershipParameters",
    type: {
        name: "Composite",
        className: "CheckGroupMembershipParameters",
        modelProperties: {
            groupId: {
                required: true,
                serializedName: "groupId",
                type: {
                    name: "String"
                }
            },
            memberId: {
                required: true,
                serializedName: "memberId",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var CheckGroupMembershipResult = {
    serializedName: "CheckGroupMembershipResult",
    type: {
        name: "Composite",
        className: "CheckGroupMembershipResult",
        modelProperties: {
            value: {
                serializedName: "value",
                type: {
                    name: "Boolean"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var ServicePrincipalBase = {
    serializedName: "ServicePrincipalBase",
    type: {
        name: "Composite",
        className: "ServicePrincipalBase",
        modelProperties: {
            accountEnabled: {
                serializedName: "accountEnabled",
                type: {
                    name: "Boolean"
                }
            },
            appRoleAssignmentRequired: {
                serializedName: "appRoleAssignmentRequired",
                type: {
                    name: "Boolean"
                }
            },
            keyCredentials: {
                serializedName: "keyCredentials",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "KeyCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            },
            passwordCredentials: {
                serializedName: "passwordCredentials",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PasswordCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            },
            servicePrincipalType: {
                serializedName: "servicePrincipalType",
                type: {
                    name: "String"
                }
            },
            tags: {
                serializedName: "tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var ServicePrincipalCreateParameters = {
    serializedName: "ServicePrincipalCreateParameters",
    type: {
        name: "Composite",
        className: "ServicePrincipalCreateParameters",
        modelProperties: __assign(__assign({}, ServicePrincipalBase.type.modelProperties), { appId: {
                required: true,
                serializedName: "appId",
                type: {
                    name: "String"
                }
            } })
    }
};
export var ServicePrincipalUpdateParameters = {
    serializedName: "ServicePrincipalUpdateParameters",
    type: {
        name: "Composite",
        className: "ServicePrincipalUpdateParameters",
        modelProperties: __assign({}, ServicePrincipalBase.type.modelProperties)
    }
};
export var ServicePrincipal = {
    serializedName: "ServicePrincipal",
    type: {
        name: "Composite",
        polymorphicDiscriminator: DirectoryObject.type.polymorphicDiscriminator,
        uberParent: "DirectoryObject",
        className: "ServicePrincipal",
        modelProperties: __assign(__assign({}, DirectoryObject.type.modelProperties), { accountEnabled: {
                serializedName: "accountEnabled",
                type: {
                    name: "Boolean"
                }
            }, alternativeNames: {
                serializedName: "alternativeNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }, appDisplayName: {
                readOnly: true,
                serializedName: "appDisplayName",
                type: {
                    name: "String"
                }
            }, appId: {
                serializedName: "appId",
                type: {
                    name: "String"
                }
            }, appOwnerTenantId: {
                readOnly: true,
                serializedName: "appOwnerTenantId",
                type: {
                    name: "String"
                }
            }, appRoleAssignmentRequired: {
                serializedName: "appRoleAssignmentRequired",
                type: {
                    name: "Boolean"
                }
            }, appRoles: {
                serializedName: "appRoles",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "AppRole"
                        }
                    }
                }
            }, displayName: {
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            }, errorUrl: {
                serializedName: "errorUrl",
                type: {
                    name: "String"
                }
            }, homepage: {
                serializedName: "homepage",
                type: {
                    name: "String"
                }
            }, keyCredentials: {
                serializedName: "keyCredentials",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "KeyCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }, logoutUrl: {
                serializedName: "logoutUrl",
                type: {
                    name: "String"
                }
            }, oauth2Permissions: {
                readOnly: true,
                serializedName: "oauth2Permissions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "OAuth2Permission"
                        }
                    }
                }
            }, passwordCredentials: {
                serializedName: "passwordCredentials",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PasswordCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }, preferredTokenSigningKeyThumbprint: {
                serializedName: "preferredTokenSigningKeyThumbprint",
                type: {
                    name: "String"
                }
            }, publisherName: {
                serializedName: "publisherName",
                type: {
                    name: "String"
                }
            }, replyUrls: {
                serializedName: "replyUrls",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }, samlMetadataUrl: {
                serializedName: "samlMetadataUrl",
                type: {
                    name: "String"
                }
            }, servicePrincipalNames: {
                serializedName: "servicePrincipalNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }, servicePrincipalType: {
                serializedName: "servicePrincipalType",
                type: {
                    name: "String"
                }
            }, tags: {
                serializedName: "tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            } }),
        additionalProperties: DirectoryObject.type.additionalProperties
    }
};
export var PasswordProfile = {
    serializedName: "PasswordProfile",
    type: {
        name: "Composite",
        className: "PasswordProfile",
        modelProperties: {
            password: {
                required: true,
                serializedName: "password",
                type: {
                    name: "String"
                }
            },
            forceChangePasswordNextLogin: {
                serializedName: "forceChangePasswordNextLogin",
                type: {
                    name: "Boolean"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var UserBase = {
    serializedName: "UserBase",
    type: {
        name: "Composite",
        className: "UserBase",
        modelProperties: {
            immutableId: {
                serializedName: "immutableId",
                type: {
                    name: "String"
                }
            },
            usageLocation: {
                serializedName: "usageLocation",
                type: {
                    name: "String"
                }
            },
            givenName: {
                serializedName: "givenName",
                type: {
                    name: "String"
                }
            },
            surname: {
                serializedName: "surname",
                type: {
                    name: "String"
                }
            },
            userType: {
                serializedName: "userType",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var UserCreateParameters = {
    serializedName: "UserCreateParameters",
    type: {
        name: "Composite",
        className: "UserCreateParameters",
        modelProperties: __assign(__assign({}, UserBase.type.modelProperties), { accountEnabled: {
                required: true,
                serializedName: "accountEnabled",
                type: {
                    name: "Boolean"
                }
            }, displayName: {
                required: true,
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            }, passwordProfile: {
                required: true,
                serializedName: "passwordProfile",
                type: {
                    name: "Composite",
                    className: "PasswordProfile",
                    additionalProperties: {
                        type: {
                            name: "Object"
                        }
                    }
                }
            }, userPrincipalName: {
                required: true,
                serializedName: "userPrincipalName",
                type: {
                    name: "String"
                }
            }, mailNickname: {
                required: true,
                serializedName: "mailNickname",
                type: {
                    name: "String"
                }
            }, mail: {
                serializedName: "mail",
                type: {
                    name: "String"
                }
            } }),
        additionalProperties: UserBase.type.additionalProperties
    }
};
export var UserUpdateParameters = {
    serializedName: "UserUpdateParameters",
    type: {
        name: "Composite",
        className: "UserUpdateParameters",
        modelProperties: __assign(__assign({}, UserBase.type.modelProperties), { accountEnabled: {
                serializedName: "accountEnabled",
                type: {
                    name: "Boolean"
                }
            }, displayName: {
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            }, passwordProfile: {
                serializedName: "passwordProfile",
                type: {
                    name: "Composite",
                    className: "PasswordProfile",
                    additionalProperties: {
                        type: {
                            name: "Object"
                        }
                    }
                }
            }, userPrincipalName: {
                serializedName: "userPrincipalName",
                type: {
                    name: "String"
                }
            }, mailNickname: {
                serializedName: "mailNickname",
                type: {
                    name: "String"
                }
            } }),
        additionalProperties: UserBase.type.additionalProperties
    }
};
export var SignInName = {
    serializedName: "SignInName",
    type: {
        name: "Composite",
        className: "SignInName",
        modelProperties: {
            type: {
                serializedName: "type",
                type: {
                    name: "String"
                }
            },
            value: {
                serializedName: "value",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var User = {
    serializedName: "User",
    type: {
        name: "Composite",
        polymorphicDiscriminator: DirectoryObject.type.polymorphicDiscriminator,
        uberParent: "DirectoryObject",
        className: "User",
        modelProperties: __assign(__assign({}, DirectoryObject.type.modelProperties), { immutableId: {
                serializedName: "immutableId",
                type: {
                    name: "String"
                }
            }, usageLocation: {
                serializedName: "usageLocation",
                type: {
                    name: "String"
                }
            }, givenName: {
                serializedName: "givenName",
                type: {
                    name: "String"
                }
            }, surname: {
                serializedName: "surname",
                type: {
                    name: "String"
                }
            }, userType: {
                serializedName: "userType",
                type: {
                    name: "String"
                }
            }, accountEnabled: {
                serializedName: "accountEnabled",
                type: {
                    name: "Boolean"
                }
            }, displayName: {
                serializedName: "displayName",
                type: {
                    name: "String"
                }
            }, userPrincipalName: {
                serializedName: "userPrincipalName",
                type: {
                    name: "String"
                }
            }, mailNickname: {
                serializedName: "mailNickname",
                type: {
                    name: "String"
                }
            }, mail: {
                serializedName: "mail",
                type: {
                    name: "String"
                }
            }, signInNames: {
                serializedName: "signInNames",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "SignInName",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            } }),
        additionalProperties: DirectoryObject.type.additionalProperties
    }
};
export var UserGetMemberGroupsParameters = {
    serializedName: "UserGetMemberGroupsParameters",
    type: {
        name: "Composite",
        className: "UserGetMemberGroupsParameters",
        modelProperties: {
            securityEnabledOnly: {
                required: true,
                serializedName: "securityEnabledOnly",
                type: {
                    name: "Boolean"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var GetObjectsParameters = {
    serializedName: "GetObjectsParameters",
    type: {
        name: "Composite",
        className: "GetObjectsParameters",
        modelProperties: {
            objectIds: {
                serializedName: "objectIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            types: {
                serializedName: "types",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            includeDirectoryObjectReferences: {
                serializedName: "includeDirectoryObjectReferences",
                type: {
                    name: "Boolean"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var Domain = {
    serializedName: "Domain",
    type: {
        name: "Composite",
        className: "Domain",
        modelProperties: {
            authenticationType: {
                readOnly: true,
                serializedName: "authenticationType",
                type: {
                    name: "String"
                }
            },
            isDefault: {
                readOnly: true,
                serializedName: "isDefault",
                type: {
                    name: "Boolean"
                }
            },
            isVerified: {
                readOnly: true,
                serializedName: "isVerified",
                type: {
                    name: "Boolean"
                }
            },
            name: {
                required: true,
                serializedName: "name",
                type: {
                    name: "String"
                }
            }
        },
        additionalProperties: {
            type: {
                name: "Object"
            }
        }
    }
};
export var OAuth2PermissionGrant = {
    serializedName: "OAuth2PermissionGrant",
    type: {
        name: "Composite",
        className: "OAuth2PermissionGrant",
        modelProperties: {
            odatatype: {
                serializedName: "odata\\.type",
                type: {
                    name: "String"
                }
            },
            clientId: {
                serializedName: "clientId",
                type: {
                    name: "String"
                }
            },
            objectId: {
                serializedName: "objectId",
                type: {
                    name: "String"
                }
            },
            consentType: {
                serializedName: "consentType",
                type: {
                    name: "String"
                }
            },
            principalId: {
                serializedName: "principalId",
                type: {
                    name: "String"
                }
            },
            resourceId: {
                serializedName: "resourceId",
                type: {
                    name: "String"
                }
            },
            scope: {
                serializedName: "scope",
                type: {
                    name: "String"
                }
            },
            startTime: {
                serializedName: "startTime",
                type: {
                    name: "String"
                }
            },
            expiryTime: {
                serializedName: "expiryTime",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var DirectoryObjectListResult = {
    serializedName: "DirectoryObjectListResult",
    type: {
        name: "Composite",
        className: "DirectoryObjectListResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "DirectoryObject",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            },
            odatanextLink: {
                serializedName: "odata\\.nextLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var ApplicationListResult = {
    serializedName: "ApplicationListResult",
    type: {
        name: "Composite",
        className: "ApplicationListResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "Application",
                            additionalProperties: DirectoryObject.type.additionalProperties
                        }
                    }
                }
            },
            odatanextLink: {
                serializedName: "odata\\.nextLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var KeyCredentialListResult = {
    serializedName: "KeyCredentialListResult",
    type: {
        name: "Composite",
        className: "KeyCredentialListResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "KeyCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
export var PasswordCredentialListResult = {
    serializedName: "PasswordCredentialListResult",
    type: {
        name: "Composite",
        className: "PasswordCredentialListResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PasswordCredential",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
export var GroupListResult = {
    serializedName: "GroupListResult",
    type: {
        name: "Composite",
        className: "GroupListResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "ADGroup",
                            additionalProperties: DirectoryObject.type.additionalProperties
                        }
                    }
                }
            },
            odatanextLink: {
                serializedName: "odata\\.nextLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GroupGetMemberGroupsResult = {
    serializedName: "GroupGetMemberGroupsResult",
    type: {
        name: "Composite",
        className: "GroupGetMemberGroupsResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var ServicePrincipalListResult = {
    serializedName: "ServicePrincipalListResult",
    type: {
        name: "Composite",
        className: "ServicePrincipalListResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "ServicePrincipal",
                            additionalProperties: DirectoryObject.type.additionalProperties
                        }
                    }
                }
            },
            odatanextLink: {
                serializedName: "odata\\.nextLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var UserListResult = {
    serializedName: "UserListResult",
    type: {
        name: "Composite",
        className: "UserListResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "User",
                            additionalProperties: DirectoryObject.type.additionalProperties
                        }
                    }
                }
            },
            odatanextLink: {
                serializedName: "odata\\.nextLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var UserGetMemberGroupsResult = {
    serializedName: "UserGetMemberGroupsResult",
    type: {
        name: "Composite",
        className: "UserGetMemberGroupsResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var DomainListResult = {
    serializedName: "DomainListResult",
    type: {
        name: "Composite",
        className: "DomainListResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "Domain",
                            additionalProperties: {
                                type: {
                                    name: "Object"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
export var OAuth2PermissionGrantListResult = {
    serializedName: "OAuth2PermissionGrantListResult",
    type: {
        name: "Composite",
        className: "OAuth2PermissionGrantListResult",
        modelProperties: {
            value: {
                serializedName: "",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "OAuth2PermissionGrant"
                        }
                    }
                }
            },
            odatanextLink: {
                serializedName: "odata\\.nextLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var discriminators = {
    'DirectoryObject': DirectoryObject,
    'DirectoryObject.Application': Application,
    'DirectoryObject.Group': ADGroup,
    'DirectoryObject.ServicePrincipal': ServicePrincipal,
    'DirectoryObject.User': User
};
//# sourceMappingURL=mappers.js.map